export function MakePaymentApiDetails(newPaymentDetails) {
  const MakePaymentData = {
    subscriberId: newPaymentDetails.subscriberId,
    payment: {
      header: {
        operation: newPaymentDetails.paymentOperation,
        //'account-number': newPaymentDetails.guarantorId,
        'account-number': newPaymentDetails.guarantorId,

        'payment-amount': newPaymentDetails.paymentAmount,
        'payment-type-code': newPaymentDetails.paymentTypeCode,
        //'check-duplicates': 'true',
        'check-duplicates': 'false',

      },
      'payment-method': {
       // token: newPaymentDetails.token,
        token: newPaymentDetails?.payToken ?? newPaymentDetails?.token ?? "",

      },
      customer: {
        'first-name': newPaymentDetails.firstName,
        'middle-name': newPaymentDetails.middleName,
        'last-name': newPaymentDetails.lastName,
        'day-phone-nr': newPaymentDetails.phoneNumber,
        email: newPaymentDetails.email,
        address: {
          line1: newPaymentDetails.addressLine1,
          state: newPaymentDetails.StateName,
          'zip-code': newPaymentDetails.postalCode,
          city: newPaymentDetails.CityName,
          country: newPaymentDetails.CountryName,
        },
      },
    },
  };
  return MakePaymentData;
}

export function MakeAutoPaymentApiDetails(newPaymentDetails) {
  const AutoPaymentData = {
    subscriberId: newPaymentDetails.subscriberId,
    // autoPay: newPaymentDetails.autoPayMethodSC,
    'payment-schedule': {
      header: {
        operation: newPaymentDetails.paymentOperation,
        'account-number': newPaymentDetails.guarantorId,
        'payment-amount': newPaymentDetails.paymentAmount,
        'payment-type-code': newPaymentDetails.paymentTypeCode,
        'schedule-day': newPaymentDetails.invoiceCycle,
        //'schedule-day': 6,

        'schedule-type-code': 'MONTHLY_BILL_AMOUNT',
        'check-duplicates': 'true',
      },
      'payment-method': {
        token: newPaymentDetails.token,
      },
      'payment-method-category': newPaymentDetails.paymentMethodCategory,

      customer: {
        'first-name': newPaymentDetails.firstName,
        'middle-name': newPaymentDetails.middleName,
        'last-name': newPaymentDetails.lastName,
        'day-phone-nr': newPaymentDetails.phoneNumber,
        email: newPaymentDetails.email,
        address: {
          line1: newPaymentDetails.addressLine1,
          state: newPaymentDetails.StateName,
          'zip-code': newPaymentDetails.postalCode,
          city: newPaymentDetails.CityName,
          country: newPaymentDetails.CountryName,
        },
      },
    },
  };
  return AutoPaymentData;
}

export function PaymentTransactionData(subscriberId, payment) {
  this.subscriberId = subscriberId;
  this.payment = payment;
}

// Example of how to create a payment object
const payment = {
  header: {
    operation: '',
    'account-number': '',
    'account-token': '',
    'payment-amount': '',
    'payment-type-code': '',
    'check-duplicates': '',
  },
  'payment-method': {
    token: '',
  },
  customer: {
    'first-name': '',
    'middle-name': '',
    'last-name': '',
    'day-phone-nr': '',
    email: '',
    address: {
      line1: '',
      state: '',
      'zip-code': '',
      city: '',
      country: '',
    },
  },
};

